import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { Ikr998ErtUsers } from "../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { Observable} from "rxjs";
import { FormGroup } from "@angular/forms";

const apiUrl = environment.apiUrl + "/kr998ErtUsers";

@Injectable({
  providedIn: "root",
})
export class Kr998ErtUsersService {
  constructor(private http: HttpClient) {}

  getAllKr998ErtUsers(): Observable<Ikr998ErtUsers[]> {
    return this.http.get<Ikr998ErtUsers[]>(`${apiUrl}`);
  }

  getByKr998Id(id: number, facilityId : number): Observable<Ikr998ErtUsers> {
    return this.http.get<Ikr998ErtUsers>(`${apiUrl}/${id}?loggedInUserFacilityId=${facilityId}`);
  }

  createKr998ErtUsers(data: Ikr998ErtUsers[]): Observable<Ikr998ErtUsers[]> {
    return this.http.post<Ikr998ErtUsers[]>(apiUrl, data);
  }

  updateERTUser(data: Ikr998ErtUsers, facilityId : number): Observable<Ikr998ErtUsers> {
    return this.http.put<Ikr998ErtUsers>(`${apiUrl}/update?loggedInUserFacilityId=${facilityId}`, data);
  }

  updateAttendanceStatus(data: Ikr998ErtUsers[]): Observable<void> {
    return this.http.put<void>(apiUrl, data);
  }
  getKr998sByUserId(userId: number): Observable<Ikr998ErtUsers[]> {
    return this.http.get<Ikr998ErtUsers[]>(`${apiUrl}/users/${userId}`);
  }
  deleteKr998ErtUsers(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${apiUrl}/${id}`);
  }

  public validate(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("userErtId")?.value) {
      errors.push("Ert User is required");
    }
    return errors;
  }
}
